import { Component, Input, ChangeDetectionStrategy } from '@angular/core'
import { Content } from '@monorepo/golab-generated'
import { TextContentComponent } from '../text-content/text-content.component'
import { AppAndLabContentComponent } from '../app-and-lab-content/app-and-lab-content.component'
import { ImageContentComponent } from '../image-content/image-content.component'
import { VideoContentComponent } from '../video-content/video-content.component'
import { WebPageContentComponent } from '../web-page-content/web-page-content.component'
import { FileContentComponent } from '../file-content/file-content.component'
import { PdfContentComponent } from '../pdf-content/pdf-content.component'

@Component({
  selector: 'app-show-content',
  templateUrl: './show-content.component.html',
  styleUrls: ['./show-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    TextContentComponent,
    AppAndLabContentComponent,
    ImageContentComponent,
    VideoContentComponent,
    WebPageContentComponent,
    FileContentComponent,
    PdfContentComponent,
  ],
})
export class ShowContentComponent {
  @Input() content: Content | undefined
  @Input() phaseId: string = ''
}
